export default __webpack_public_path__ + "static/media/hm_amazonfeat.7e694676.jpg";